import React, { type MouseEventHandler } from 'react';

import { type SxProps } from '@mui/material';

import { type ButtonProps } from '../button';
import { Loader } from '../loader';

import { StyledLinkButton } from './link-button.styles';

export type LinkButtonProps = ButtonProps & {
  automationId?: string;
  className?: string;
  label: React.ReactNode | string;
  loading?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps;
  variant?: 'primary' | 'secondary';
};

// THIS IS A BUTTON STYLED TO LOOK LIKE A LINK
export function LinkButton({
  label,
  variant = 'primary',
  onClick,
  sx,
  disabled = false,
  loading = false,
  automationId = '',
  className,
}: LinkButtonProps): JSX.Element {
  return (
    <StyledLinkButton
      $variant={variant}
      className={className}
      data-testid={automationId}
      disabled={disabled}
      sx={sx}
      onClick={onClick}
    >
      {!loading && label}
      {loading && <Loader variant={variant === 'primary' ? 'blue' : 'black'} />}
    </StyledLinkButton>
  );
}
